import { gql, useFragment } from "@apollo/client";

// Components
import Link from "next/link";
import IconFA from "../icon-fa/icon-fa";

// Styling
import style from "./social-icons.module.scss";

export default function SocialIcons({ id }) {
  // Use Fragment
  const { complete, data } = useFragment({
    fragment: SocialIcons.fragments.entry,
    fragmentName: "SocialIconsFragment",
    from: {
      __typename: "GeneralSettingsACF",
      id: id,
    },
  });
  if (!complete) {
    return;
  }

  return (
    <div className={style.socialIcons}>
      {data.socialMedia.map((item) => {
        return (
          <Link href={item.url} target="_blank" key={item.id}>
            <IconFA name={item.platform} color="var(--color--font)" />
            <span className="sr-only">Opens a new tab.</span>
          </Link>
        );
      })}
    </div>
  );
}

SocialIcons.fragments = {
  entry: gql`
    fragment SocialIconsFragment on GeneralSettingsACF {
      __typename
      id
      socialMedia {
        id
        __typename
        platform
        url
      }
    }
  `,
};
